import { useQuery } from '@tanstack/react-query';

import api from 'api';
import { mapProgramListResponse } from 'helpers/eligibility';
import type { ProgramOption } from 'types';

export const programListKeys = {
    all: ['programList'] as const,
    byCountry: (country: string) => ['programList', country] as const,
};

/**
 * GET /program_list?country=
 * Cached per country so switching country (or re-opening eligibility) does not
 * re-fetch while the entry is still fresh.
 */
export const useProgramList = (country?: string, options?: { enabled?: boolean }) => {
    const normalizedCountry = country?.trim() ?? '';

    return useQuery<ProgramOption[]>({
        queryKey: programListKeys.byCountry(normalizedCountry),
        queryFn: async () => {
            const response = await api.programList.get(undefined, normalizedCountry);
            if (response?.status !== 200 && response?.status !== 201) {
                return [];
            }
            return mapProgramListResponse(response?.data);
        },
        enabled: (options?.enabled ?? true) && Boolean(normalizedCountry),
        staleTime: 5 * 60 * 1000,
    });
};
